import React, { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { IconEye, IconEyeOff } from "@tabler/icons";
import CustomFormLabel from "./CustomFormLabel";

// The CMS text field: label above (always visible), the field, and the error
// as a plain sentence under it. Same props as before:
//   Title, placeholder, inputMode ("text" | "email" | "number" | "password"),
//   multiline + numberOfLines, maxLength (long text only), readOnly,
//   Customestyle (wrapper style), customeStyleText (field style), errors,
//   onPress, and anything TextField takes (value, onChange(event), id, ...).
// The template version passed its own props on to the page (React warnings),
// and its label was not tied to the input.
const CustomTextField = (props) => {
  const {
    Title = "",
    placeholder = "",
    inputMode = "text",
    maxLength,
    multiline = false,
    numberOfLines = 1,
    readOnly = false,
    Customestyle,
    customeStyleText,
    errors,
    onPress,
    // Formik's <Field component> extras: not for the DOM.
    field, // eslint-disable-line no-unused-vars
    form, // eslint-disable-line no-unused-vars
    value = "",
    id,
    name,
    InputProps,
    inputProps,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const fieldId = id || name || undefined;
  const isPassword = inputMode === "password" || rest.type === "password";
  const errorText = typeof errors === "string" ? errors.charAt(0).toUpperCase() + errors.slice(1) : errors;
  const type = isPassword ? (showPassword ? "text" : "password") : rest.type || (inputMode === "textarea" ? "text" : inputMode);

  return (
    <div style={Customestyle} onClick={onPress ? () => onPress() : undefined}>
      {Title ? <CustomFormLabel htmlFor={fieldId}>{Title}</CustomFormLabel> : null}
      <TextField
        id={fieldId}
        name={name}
        placeholder={placeholder}
        value={value ?? ""}
        disabled={readOnly}
        multiline={multiline}
        minRows={multiline ? Math.max(numberOfLines, 3) : undefined}
        style={multiline ? { ...customeStyleText, height: undefined } : customeStyleText}
        error={!!errors}
        helperText={errorText || undefined}
        FormHelperTextProps={errorText ? { role: "alert" } : undefined}
        inputProps={{ ...(multiline && maxLength ? { maxLength } : {}), ...inputProps }}
        InputProps={{
          endAdornment: isPassword ? (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? "Hide the password" : "Show the password"}
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
              </IconButton>
            </InputAdornment>
          ) : undefined,
          ...InputProps,
        }}
        {...rest}
        type={type}
      />
    </div>
  );
};

export default CustomTextField;
